export default __webpack_public_path__ + "static/media/gallery_02.109948db.jpg";